import { atom } from "recoil";


const wishListBox = atom({
  key: 'wishListBox', 
  default: false, 
 });


 export default wishListBox;

